import React, { Fragment, useEffect, useState } from 'react';
type CountdownTimerProps = {
  size?: 'compact' | 'large';
  dark?: boolean;
};
type TimeParts = {
  hours: number;
  minutes: number;
  seconds: number;
};
function getTimeParts(target: number): TimeParts {
  const remaining = Math.max(0, target - Date.now());
  return {
    hours: Math.floor(remaining / 3600000),
    minutes: Math.floor(remaining % 3600000 / 60000),
    seconds: Math.floor(remaining % 60000 / 1000)
  };
}
export function CountdownTimer({
  size = 'compact',
  dark = false
}: CountdownTimerProps) {
  const [target] = useState(() => Date.now() + 86400000);
  const [time, setTime] = useState(() => getTimeParts(target));
  useEffect(() => {
    const interval = window.setInterval(() => setTime(getTimeParts(target)), 1000);
    return () => window.clearInterval(interval);
  }, [target]);
  const valueClass = size === 'large' ? 'text-5xl sm:text-6xl' : 'text-2xl sm:text-3xl';
  const labelClass = size === 'large' ? 'text-[10px]' : 'text-[9px]';
  const parts: Array<[number, string]> = [[time.hours, 'hours'], [time.minutes, 'min'], [time.seconds, 'sec']];
  return <div className="flex items-start justify-center gap-3 sm:gap-4" aria-label={`Offer ends in ${time.hours} hours, ${time.minutes} minutes and ${time.seconds} seconds`} data-id="element-19" data-mp="1gxf5339tmfbm">
      {parts.map(([value, label], index) => <Fragment key={label} data-id="element-20" data-mp="1uqwnuluono0l" data-mpi={index}>
          {index > 0 && <span aria-hidden="true" className={`${valueClass} font-display font-semibold leading-none ${dark ? 'text-stone-500' : 'text-stone-300'}`} data-id="element-21" data-mp="1utiu8i5u7xh8">
              :
            </span>}
          <div className="text-center" data-id="element-22" data-mp="1pzobbgy23mj7">
            <div className={`${valueClass} font-display font-semibold leading-none tabular-nums ${dark ? 'text-white' : 'text-ink-900'}`} data-id="element-23" data-mp="1pyn3dlcc7g5p">
              {String(value).padStart(2, '0')}
            </div>
            <div className={`${labelClass} mt-2 font-semibold uppercase tracking-[.2em] ${dark ? 'text-stone-300' : 'text-ink-600'}`} data-id="element-24" data-mp="2scr7jmlu8mqi">
              {label}
            </div>
          </div>
        </Fragment>)}
    </div>;
}